import React, { useState } from 'react';
import { Power, AlertTriangle } from 'lucide-react';
import Modal from './Modal';

// Confirma la activación del cobro en todas las cuentas cliente de Punto V.
// Pensado para después de la migración que las deja todas sin cobro.
const DialogoHabilitarTodos = ({ slugs, sinVincular, onConfirmar, onCancel }) => {
  const [error, setError] = useState('');
  const [guardando, setGuardando] = useState(false);

  const confirmar = async () => {
    setError('');
    setGuardando(true);
    try {
      await onConfirmar();
    } catch (err) {
      setError(err.message || 'No se pudo activar el cobro');
      setGuardando(false);
    }
  };

  return (
    <Modal
      titulo="Activar cobro a todos"
      subtitulo="Cuentas cliente configuradas en Punto V"
      icono={Power}
      onClose={onCancel}
      bloqueado={guardando}
      pie={(
        <>
          <button type="button" onClick={onCancel} disabled={guardando} className="px-4 py-2 text-sm text-gray-700 rounded-lg hover:bg-gray-100">Cancelar</button>
          <button type="button" onClick={confirmar} disabled={guardando} className="px-4 py-2 bg-blue-600 text-white rounded-lg hover:bg-blue-700 text-sm font-medium disabled:opacity-50">
            {guardando ? 'Activando…' : 'Activar cobro'}
          </button>
        </>
      )}
    >
      <div className="space-y-4 text-sm text-gray-700">
        <p>
          Se activará el cobro de la mensualidad en <strong>{slugs.length}</strong> {slugs.length === 1 ? 'cuenta que está' : 'cuentas que están'} sin cobro.
          Los clientes sin configurar y las zonas Punto V no se tocan.
        </p>
        <p className="text-xs text-gray-600 break-words">{slugs.join(', ')}</p>
        {sinVincular.length > 0 && (
          <div className="bg-amber-50 border border-amber-200 text-amber-800 rounded-xl p-3 flex items-start gap-2">
            <AlertTriangle size={16} className="mt-0.5 flex-shrink-0" />
            <span>
              {sinVincular.length === 1 ? 'Una cuenta no está vinculada' : `${sinVincular.length} cuentas no están vinculadas`} a un cliente del ERP
              ({sinVincular.join(', ')}). Su cotización no se podrá emitir hasta vincularlas.
            </span>
          </div>
        )}
        {error && (
          <div className="bg-red-50 border border-red-200 text-red-700 rounded-xl p-3 flex items-start gap-2">
            <AlertTriangle size={16} className="mt-0.5 flex-shrink-0" /> <span>{error}</span>
          </div>
        )}
      </div>
    </Modal>
  );
};

export default DialogoHabilitarTodos;
